import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  defaultSearchTerm: 'Timberland',
  brandClasses: {
    suggestions: {
      title: 'subtitle-4 md:subtitle-3',
      products: 'w-full flex gap-x-4 grid cols-2 lg:w-134 gap-x-6 gap-y-8',
      item: 'relative w-a shrink-0 gap-2 lg:flex',
    }
  }
} satisfies RecursivePartial<VfConfig['search']>
